import { render, staticRenderFns } from "./CTable.vue?vue&type=template&id=36389a47&scoped=true&"
import script from "./CTable.vue?vue&type=script&lang=js&"
export * from "./CTable.vue?vue&type=script&lang=js&"
import style0 from "./CTable.vue?vue&type=style&index=0&id=36389a47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36389a47",
  null
  
)

export default component.exports